import React, { useState, useEffect } from 'react';
import PageLink from 'components/PageLink/PageLink';
import { getTemplateToken } from 'common/helpers/tokensFormatter';
import { getTemplateString } from 'common/helpers/string';
import { ManualPaymentBannerType } from 'common/consts/manualPaymentBanner';
import styles from './ManualPaymentBanner.module.scss';
import classnames from 'classnames';
import Icon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';

type Props = {
  PageData?: any;
  Model?: any;
};

const ManualPaymentBanner = ({ PageData, Model }: Props) => {
  const agreedInstalmentAmountTokenName = '{AgreedInstalmentAmount}';
  const nextInstalmentAmountTokenName = '{NextInstalmentAmount}';
  const agreedInstalmentAmountToken = getTemplateToken(
    Model?.FormattedCurrencyAgreedInstalmentAmount,
  );
  const nextInstalmentAmountToken = getTemplateToken(
    Model?.FormattedCurrencyNextInstalmentAmount,
  );
  const arrearPaymentAmountToken = getTemplateToken(
    Model?.FormattedCurrencyarrearAmount,
  );
  const nextPaymentDateToken = getTemplateToken(
    Model?.DebtOverviewPanelViewModel?.NextPaymentDueDateText,
  );
  const upcomingInstallmentNotice = getTemplateString(
    PageData?.UpcomingPaymentNotice,
  );
  const arrearPaymentNotice = getTemplateString(PageData?.ArrearPaymentNotice);
  const upcomingAndArrearPaymentNotice = getTemplateString(
    PageData?.NextInstalmentAmount,
  );
  const [showDetails, setShowDetails] = useState(false);

  const [
    showManualBannerUpcoming,
    setShowManualBannerUpcoming,
  ] = useState(true); 

  const [
    showArrearBannerUpcomingAndArrear,
    setShowArrearBannerUpcomingAndArrear,
  ] = useState(true); 

  useEffect(() => {
    if (Model?.IsSecuredUser) {
    setShowManualBannerUpcoming(Model?.Profile?.Segment == "5")
    setShowArrearBannerUpcomingAndArrear (Model?.Profile?.Segment == "5" || Model?.Profile?.Segment == "1")
    }
  }, [Model]);

  // TODO: Replace placeholders
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>{PageData?.AttentionUrgentHeader}</div>
      <div className={styles.content}>
        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.Upcoming && 
          showManualBannerUpcoming && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{
              __html: upcomingInstallmentNotice
                ? upcomingInstallmentNotice({
                    AgreedInstalmentAmount: agreedInstalmentAmountToken,
                    NextInstalmentAmount: nextInstalmentAmountToken,
                    NextPaymentDate: nextPaymentDateToken,
                  })
                : '',
            }}
          />
        )}

        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.UpcomingAndArrears && 
          showArrearBannerUpcomingAndArrear && (
          <div
            data-type="Alert"
            data-creative-slot="Portal-Home-Top"
            data-alert-name="Arrears"
          >
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{
                __html: upcomingAndArrearPaymentNotice
                  ? upcomingAndArrearPaymentNotice({
                      NextInstalmentAmount: nextInstalmentAmountToken,
                    })
                  : '',
              }}
            />
          </div>
        )}
        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.Arrears &&
          showArrearBannerUpcomingAndArrear && (
          <div
            data-type="Alert"
            data-creative-slot="Portal-Home-Top"
            data-alert-name="Arrears"
          >
            <div
              className={styles.text}
              dangerouslySetInnerHTML={{
                __html: arrearPaymentNotice
                  ? arrearPaymentNotice({
                      ArrearsAmount: arrearPaymentAmountToken,
                    })
                  : '',
              }}
            />
          </div>
        )}
        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.Upcoming &&
          showManualBannerUpcoming &&
          (PageData?.UpcomingPaymentNotice.includes(
            agreedInstalmentAmountTokenName,
          ) ? (
            <PageLink
              url={
                Model?.SinglePaymentPage?.Uri +
                '&manualPaymentAmount=' +
                Model?.AgreedInstalmentAmountText
              }
              text={PageData?.ManualPaymentButtonLabel}
              className={styles.link}
              disabled={false}
            />
          ) : PageData?.UpcomingPaymentNotice.includes(
              nextInstalmentAmountTokenName,
            ) ? (
            <PageLink
              url={
                Model?.SinglePaymentPage?.Uri +
                '&manualPaymentAmount=' +
                Model?.NextInstalmentAmountText
              }
              text={PageData?.ManualPaymentButtonLabel}
              className={styles.link}
              disabled={false}
            />
          ) : (
            <PageLink
              url={Model?.SinglePaymentPage?.Uri}
              text={PageData?.ManualPaymentButtonLabel}
              className={styles.link}
              disabled={false}
            />
          ))}

        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.UpcomingAndArrears &&
          showArrearBannerUpcomingAndArrear && (
          <PageLink
            url={
              Model?.SinglePaymentPage?.Uri +
              '&manualPaymentAmount=' +
              Model?.NextInstalmentAmountText
            }
            text={PageData?.ManualPaymentButtonLabel}
            className={styles.link}
            disabled={false}
          />
        )}

        {Model?.DisplayManualPaymentBanner ===
          ManualPaymentBannerType.Arrears &&
          showArrearBannerUpcomingAndArrear && (
          <PageLink
            url={
              Model?.SinglePaymentPage?.Uri +
              '&manualPaymentAmount=' +
              Model?.ArrearsAmountText
            }
            text={PageData?.ManualPaymentButtonLabel}
            className={styles.link}
            disabled={false}
          />
        )}
        {Model?.IsSecuredUser &&
        (<div className={styles.paycheck}>
          <button
            className={classnames(
              styles.paycheckbtn,
              showDetails && styles.expanded,
            )}
            onClick={() => setShowDetails(!showDetails)}
          >
            {PageData?.PayByCheckText}
            <Icon
              type={SvgIcons.CHEVRON_ICON}
              width={14}
              height={14}
              className={classnames(
                styles.expandIcon,
                showDetails && styles.expanded,
              )}
            />
          </button>
                {showDetails && 
          (<div className={styles.paycheckcotent}>
            <p className={styles.paycheckcotent_text}>
            {PageData?.PleaseSendCheckText}
            </p>
            <div className={styles.paycheckcotent_address}>
              <h2 className={styles.paycheckcotent_address_heading}>{PageData?.AddressHeadingText}</h2>
              <p className={styles.paycheckcotent_address_text}>
                {PageData?.CheckAddressValuesText}
              </p>
            </div>
          </div>)
          }
        </div>)
        }
      </div>
    </div>
  );
};

export default ManualPaymentBanner;
